export interface FeedItem {
  id: string;
  cat: string;
  tag: string;
  title: string;
  summary: string;
  author: string;
  time: string;
  views: string;
  comments: string;
  img: string;
}

export interface HotItem {
  title: string;
  tag: string;
  heat: string;
  up: boolean;
}

export interface FeatureItem {
  kicker: string;
  title: string;
  summary: string;
  reads: string;
  minutes: string;
  img: string;
}

export interface TopicItem {
  label: string;
  title: string;
  summary: string;
  count: string;
  img: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const NAV_ITEMS = [
  { id: "#hotlist", label: "热榜速递" },
  { id: "#gallery", label: "分类图文" },
  { id: "#feature", label: "深度盘点" },
  { id: "#topic", label: "话题专题" },
  { id: "#faq", label: "常见问题" },
  { id: "#about", label: "关于我们" },
] as const;

export const HOT_WORDS = [
  "红毯造型",
  "演唱会名场面",
  "综艺修罗场",
  "团综路透",
  "代言官宣",
  "音综翻唱",
  "站姐文化",
  "悬念剧结局",
] as const;

export const CATEGORIES = [
  { id: "all", name: "全部" },
  { id: "star", name: "明星动向" },
  { id: "show", name: "综艺现场" },
  { id: "film", name: "影视热讯" },
  { id: "music", name: "乐坛动态" },
  { id: "fashion", name: "时尚红毯" },
] as const;

export const HOT_LIST: HotItem[] = [
  { title: "顶流男团海外巡演被曝“音响偏音”，现场视频引全网热议", tag: "爆", heat: "热度 987.2 万", up: true },
  { title: "悬疑剧《迷雾街区》大结局反转，三个细节成破局关键", tag: "热", heat: "热度 862.4 万", up: true },
  { title: "当红小花红毯新造型“大胆又清透”，网友两极讨论", tag: "热", heat: "热度 741.8 万", up: true },
  { title: "音乐节主办方深夜回应设备故障，官方道歉并全额退场", tag: "沸", heat: "热度 655.1 万", up: true },
  { title: "综艺《周五嗨翻天》嘉宾游戏名场面合集播放破千万", tag: "热", heat: "热度 540.7 万", up: true },
  { title: "站姐“退圈信”刷屏背后：应援成本与情绪透支成话题", tag: "新", heat: "热度 431.9 万", up: true },
  { title: "一线美妆品牌官宣新任亚洲区代言人，营销文案出圈", tag: "新", heat: "热度 386.5 万", up: true },
  { title: "喜剧演员跨界主持被指“节奏不熟”，团队回应继续打磨", tag: "温", heat: "热度 298.3 万", up: false },
  { title: "年度音综翻唱名场面盘点：被低估的宝藏舞台有哪些", tag: "温", heat: "热度 245.6 万", up: true },
  { title: "粉丝应援灯光海点亮冬夜，主办方发图致谢", tag: "温", heat: "热度 189.2 万", up: false },
];

export const FEATURES: FeatureItem[] = [
  {
    kicker: "事件还原 · 时间线",
    title: "一场“翻红”到“翻车”的48小时：顶流综艺翻红事件全复盘",
    summary: "从首播热搜到舆情发酵，我们用逐小时时间线还原事件脉络，梳理各方的首次回应、二次说明与公开证据的递进关系，帮你跳出断章取义，看清完整经过。",
    reads: "阅读 128.6 万",
    minutes: "约 8 分钟",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20photography%20of%20a%20glamorous%20red%20carpet%20awards%20gala%20entrance%20at%20night%2C%20crowd%20silhouettes%20with%20camera%20flashes%20bokeh%2C%20deep%20red%20velvet%20and%20charcoal%20tones%2C%20cinematic%20moody%20lighting%2C%20high%20detail%2C%20no%20text&width=900&height=640&seq=feat-recap-01&orientation=landscape",
  },
  {
    kicker: "公域讨论 · 证据梳理",
    title: "从聊天截图到官方声明：一份“实锤汇总”的正确打开方式",
    summary: "当一张截图传遍全网，如何判断信息密度与来源可信度？我们拆解实锤类信息的五个核查维度：时间戳、上下文、多方信源、跟进回应与平台标记。",
    reads: "阅读 96.3 万",
    minutes: "约 6 分钟",
    img: "https://readdy.ai/api/search-image?query=flat%20lay%20editorial%20of%20printed%20news%20magazines%2C%20polaroid%20photos%20and%20red%20accent%20stationery%20on%20a%20warm%20paper%20desk%2C%20journalism%20research%20mood%2C%20soft%20window%20light%2C%20warm%20tones%2C%20no%20text&width=900&height=640&seq=feat-guide-02&orientation=landscape",
  },
  {
    kicker: "趋势分析 · 行业观察",
    title: "吃瓜文化二十年：从论坛爆料到短视频“实锤”时代",
    summary: "我们回溯吃瓜话题如何从早期论坛的零散帖子，演变为今天带时间线、图文对照与逐帧解读的完整内容形态，以及这一变化如何重塑了公众的围观方式。",
    reads: "阅读 74.9 万",
    minutes: "约 10 分钟",
    img: "https://readdy.ai/api/search-image?query=neon-lit%20television%20variety%20show%20studio%20set%20with%20colorful%20warm%20lights%20and%20shallow%20depth%20of%20field%2C%20modern%20broadcast%20design%2C%20vibrant%20yet%20tasteful%2C%20cinematic%2C%20no%20text&width=900&height=640&seq=feat-history-03&orientation=landscape",
  },
];

export const TOPICS: TopicItem[] = [
  {
    label: "人物 · 群像",
    title: "聚光灯下的她们：退圈、转型与二次创业",
    summary: "以近一年公开的行业变动为样本，观察艺人转行幕后、跨界创业与回归家庭三条路径，记录不同选择背后的真实考量。",
    count: "已收录 26 篇",
    img: "https://readdy.ai/api/search-image?query=backstage%20dressing%20room%20scene%20with%20warm%20vanity%20mirror%20lights%2C%20wardrobe%20rack%20and%20soft%20golden%20glow%2C%20behind%20the%20scenes%20editorial%20mood%2C%20soft%20focus%2C%20no%20text&width=960&height=600&seq=topic-people-01&orientation=landscape",
  },
  {
    label: "圈层 · 生态",
    title: "饭圈进化论：应援、反黑与理性追星指南",
    summary: "拆解应援文化、粉丝管理机制与反黑流程，既呈现热情的创造力，也探讨边界意识与情绪消耗，提供可落地的理性追星建议。",
    count: "已收录 18 篇",
    img: "https://readdy.ai/api/search-image?query=creative%20fan%20made%20light%20stick%20and%20merchandise%20display%20on%20a%20table%2C%20warm%20string%20lights%20bokeh%2C%20concert%20vibe%2C%20editorial%20still%20life%2C%20no%20text&width=960&height=600&seq=topic-fandom-02&orientation=landscape",
  },
  {
    label: "现场 · 实录",
    title: "演唱会与音乐节纪事：嗨点与槽点并存的现场",
    summary: "从设备故障到歌单编排，从安保动线到散场秩序，以亲历者视角还原大型现场的真实体验，理性讨论可改进之处。",
    count: "已收录 31 篇",
    img: "https://readdy.ai/api/search-image?query=energetic%20music%20festival%20crowd%20at%20sunset%20with%20raised%20hands%20and%20confetti%2C%20warm%20golden%20haze%2C%20documentary%20concert%20photography%2C%20no%20text&width=960&height=600&seq=topic-live-03&orientation=landscape",
  },
];

export const ARTICLES: FeedItem[] = [
  {
    id: "a1",
    cat: "fashion",
    tag: "红毯",
    title: "当红小花红毯新造型“大胆又清透”，高定细节逐帧拆解",
    summary: "造型师首度公开设计手稿，礼服剪裁与妆容逻辑引发新一轮模仿潮。",
    author: "瓜妹观察",
    time: "12 分钟前",
    views: "32.6 万",
    comments: "1.4 万",
    img: "https://readdy.ai/api/search-image?query=elegant%20fashion%20editorial%20portrait%20of%20a%20young%20woman%20in%20a%20flowing%20red%20evening%20gown%20on%20a%20beige%20studio%20backdrop%2C%20soft%20window%20light%2C%20magazine%20beauty%20lighting%2C%20warm%20tones%2C%20no%20text&width=720&height=480&seq=feed-fashion-01&orientation=landscape",
  },
  {
    id: "a2",
    cat: "show",
    tag: "综艺",
    title: "《周五嗨翻天》游戏名场面：被“心眼子”支配的一期",
    summary: "三位常驻嘉宾互相“埋雷”，编剧回应的规则漏洞反而成就全场最佳。",
    author: "片场探班",
    time: "35 分钟前",
    views: "28.1 万",
    comments: "9800",
    img: "https://readdy.ai/api/search-image?query=vibrant%20gameshow%20studio%20set%20with%20colorful%20panels%20and%20warm%20stage%20lighting%2C%20cheerful%20energy%2C%20television%20broadcast%20editorial%2C%20no%20text&width=720&height=480&seq=feed-show-02&orientation=landscape",
  },
  {
    id: "a3",
    cat: "film",
    tag: "热播",
    title: "《迷雾街区》大结局：三个被忽略的镜头暗示了全部",
    summary: "从片头时钟到背景电台，主创称所有伏笔在第一集就已埋下。",
    author: "追剧清单",
    time: "1 小时前",
    views: "54.3 万",
    comments: "2.1 万",
    img: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20an%20actor%20standing%20under%20warm%20streetlights%20on%20a%20rain%20slicked%20night%20street%20in%20an%20old%20town%2C%20teal%20and%20amber%20film%20look%2C%20moody%2C%20no%20text&width=720&height=480&seq=feed-film-03&orientation=landscape",
  },
  {
    id: "a4",
    cat: "music",
    tag: "现场",
    title: "音乐节设备故障风波后续：主办方全额退场并补偿往返交通",
    summary: "第二轮声明公布补偿细则，乐迷评价从愤怒转向“态度可嘉”。",
    author: "乐评手记",
    time: "2 小时前",
    views: "41.7 万",
    comments: "1.7 万",
    img: "https://readdy.ai/api/search-image?query=music%20festival%20main%20stage%20with%20huge%20speaker%20arrays%20and%20warm%20amber%20lights%20over%20an%20open%20field%2C%20energetic%20atmosphere%2C%20no%20text&width=720&height=480&seq=feed-music-04&orientation=landscape",
  },
  {
    id: "a5",
    cat: "star",
    tag: "代言",
    title: "一线美妆官宣新任亚洲区代言人，一支广告片刷屏社交圈",
    summary: "文案“回归本我”的叙事与品牌视觉全新升级同步上线，反响两极。",
    author: "圈内快报",
    time: "3 小时前",
    views: "23.9 万",
    comments: "8600",
    img: "https://readdy.ai/api/search-image?query=minimal%20perfume%20bottle%20product%20campaign%20on%20a%20warm%20terracotta%20backdrop%20with%20a%20soft%20sculptural%20shadow%2C%20luxury%20beauty%20editorial%2C%20no%20text&width=720&height=480&seq=feed-brand-05&orientation=landscape",
  },
  {
    id: "a6",
    cat: "show",
    tag: "路透",
    title: "老牌访谈节目改版上线：更松弛的追问为何更“抓人”",
    summary: "节目组舍弃流程化提问，转向“顺着答话走”的即兴对话，收视回暖。",
    author: "荧幕笔记",
    time: "4 小时前",
    views: "19.4 万",
    comments: "6100",
    img: "https://readdy.ai/api/search-image?query=cozy%20talk%20show%20sofa%20set%20in%20a%20warm%20studio%20with%20warm%20practical%20lamps%20and%20bookshelves%2C%20relaxed%20intimate%20editorial%2C%20no%20text&width=720&height=480&seq=feed-talk-06&orientation=landscape",
  },
  {
    id: "a7",
    cat: "music",
    tag: "音综",
    title: "年度音综“翻唱名场面”Top10：被低估的宝藏舞台盘点",
    summary: "从编曲巧思到咬字情绪，资深乐评人逐首点评为何它们值得循环。",
    author: "耳畔企划",
    time: "5 小时前",
    views: "36.8 万",
    comments: "1.2 万",
    img: "https://readdy.ai/api/search-image?query=singer%20with%20a%20microphone%20on%20a%20warmly%20lit%20performance%20stage%20with%20soft%20orange%20spotlights%20and%20haze%2C%20emotional%20atmosphere%2C%20editorial%2C%20no%20text&width=720&height=480&seq=feed-cover-07&orientation=landscape",
  },
  {
    id: "a8",
    cat: "fashion",
    tag: "街拍",
    title: "本季时装周外场街拍观察：松弛感穿搭正在取代用力过猛",
    summary: "从风衣到阔腿裤，造型师总结当下最受欢迎的五个“不费力”公式。",
    author: "街拍前线",
    time: "6 小时前",
    views: "17.5 万",
    comments: "5400",
    img: "https://readdy.ai/api/search-image?query=stylish%20street%20fashion%20portrait%20of%20a%20person%20in%20an%20oversized%20cream%20trench%20coat%20walking%20in%20warm%20sunlight%20urban%20setting%2C%20editorial%20photography%2C%20no%20text&width=720&height=480&seq=feed-street-08&orientation=landscape",
  },
  {
    id: "a9",
    cat: "star",
    tag: "专访",
    title: "站姐转型纪实：镜头之后，她们如何“体面退圈”",
    summary: "三位受访者聊应援成本、情绪透支与告别时的真实心态，理性又动人。",
    author: "人物记录",
    time: "7 小时前",
    views: "28.7 万",
    comments: "1.1 万",
    img: "https://readdy.ai/api/search-image?query=photographer%20holding%20a%20long%20lens%20camera%20in%20warm%20afternoon%20light%20backstage%2C%20blurred%20stage%20lights%20background%2C%20documentary%20editorial%2C%20no%20text&width=720&height=480&seq=feed-person-09&orientation=landscape",
  },
];

export const FAQS: FaqItem[] = [
  {
    q: "这里的“实锤汇总”是如何生产的？",
    a: "我们的编辑会围绕某个热点事件，从公开信源出发，把截图、音频、视频、时间线回应等素材按顺序整理成一篇带脉络的内容。标题与正文都明确标注“整理/梳理/据公开报道”等口径，不做虚构结论，也绝不虚构人物实名实锤。",
  },
  {
    q: "看到一张传播很广的截图，怎么判断可信度？",
    a: "建议至少核对五件事：截图是否被平台标记过、是否有多方独立信源相互印证、当事人是否有跟进回应、原始发布时间是否被裁剪、以及传播账号的历史公信力。单张无上下文截图通常不足以当作定论。",
  },
  {
    q: "网站会收录涉及隐私的聊天记录或录音吗？",
    a: "不会。对可能涉及个人隐私、未经同意传播的聊天记录与录音，我们一律不收录、不转载。我们只对已在公开领域被广泛讨论且符合公共知情需要的信息做客观梳理，任何内容都以不侵犯隐私与名誉权为前提。",
  },
  {
    q: "为什么每篇内容都强调“时间线”和“多方说法”？",
    a: "因为舆论场最常见的误区就是断章取义。按时间线呈现能让事件脉络一目了然，保留多方回应则让读者自行判断，而不是被单一叙事带节奏。这也是我们内容分层的核心原则。",
  },
  {
    q: "你们如何确保内容不涉及人身攻击与造谣？",
    a: "编辑规范要求：所有判定性表述必须建立在可引用的公开证据上；对未经证实的说法统一使用“据称”“消息称”等限定词；收到权利人指正后，我们承诺在核实后于 24 小时内更正或下架。",
  },
  {
    q: "发现内容有误或需要投诉，如何联系你们？",
    a: "可通过页面底部邮箱 hello@chiguaheilia.com 提交更正或投诉请求，邮件中请附上问题定位与相关凭证。我们会在 2 个工作日内由值班编辑完成核验并给出处理结果。",
  },
];